import React, { useState, useEffect } from "react";
import { Alert } from "reactstrap";
import GameMap from "../Maps/logic/GameMap";
import { mapConfigs } from "../Maps/MapConfig/mapConfigs";
import "./RadiantIsleWidget.css";

const RadiantIsleWidget = () => {
  const [isleStatus, setIsleStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch isle status on component mount
  useEffect(() => {
    const fetchIsleStatus = async () => {
      try {
        // You can add an API call here to check isle availability/cooldown
        // For now, we'll assume it's always available
        setIsleStatus({
          available: true,
          cooldown: null,
          lastVisit: null
        });
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch isle status:", err);
        setError("Unable to load isle status");
        setLoading(false);
      }
    };

    fetchIsleStatus();
  }, []);

  if (loading) {
    return (
      <div className="mb-4">
        <h5 style={{ 
          color: "#ffffff", 
          fontWeight: "600",
          marginBottom: "1rem",
          paddingLeft: "0.5rem",
          borderLeft: "3px solid rgba(147, 51, 234, 0.8)"
        }}>Radiant Isle</h5>
        <div style={{ 
          color: "rgba(255, 255, 255, 0.7)",
          backgroundColor: "var(--page-bg-secondary)",
          borderRadius: "8px",
          padding: "1.5rem",
          textAlign: "center",
          border: "1px solid rgba(var(--theme-accent-rgb), 0.2)"
        }}>
          <div className="spinner-border text-primary" role="status" style={{ width: "2rem", height: "2rem" }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 mb-0">Loading Radiant Isle...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mb-4">
        <h5 style={{ 
          color: "#ffffff", 
          fontWeight: "600",
          marginBottom: "1rem",
          paddingLeft: "0.5rem",
          borderLeft: "3px solid var(--theme-accent)"
        }}>Radiant Isle</h5>
        <Alert color="warning">
          <h6>Radiant Isle Unavailable</h6>
          <small>{error}</small>
        </Alert>
      </div>
    );
  }

  if (!isleStatus?.available) {
    return (
      <div className="mb-4">
        <h5 style={{ 
          color: "#ffffff", 
          fontWeight: "600",
          marginBottom: "1rem",
          paddingLeft: "0.5rem",
          borderLeft: "3px solid var(--theme-accent)"
        }}>Radiant Isle</h5>
        <Alert color="info">
          <h6>Radiant Isle On Cooldown</h6>
          <small>The Radiant Isle is currently unavailable. Please try again later.</small>
        </Alert>
      </div>
    );
  }

  return (
    <div className="radiant-isle-widget">
      <h5 style={{ 
        color: "#ffffff", 
        fontWeight: "600",
        marginBottom: "1rem",
        paddingLeft: "0.5rem",
        borderLeft: "3px solid var(--theme-accent)"
      }}>Radiant Isle</h5>
      
      <GameMap config={mapConfigs.island} />
    </div>
  );
};

export default RadiantIsleWidget;
